import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import FormDialog from '../../../components/ui/FormDialog';
import { notify, getErrorMessage } from '../../../components/feedback/notify';

export default function ModalRecuperarSenha(props) {

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        props.setModalRecuperarSenha(false);
    };

    const handleChangePassword = async () => {
        if (!email) {
            notify.warning("Por favor, insira seu e-mail.");
            return;
        }
        try {
            setLoading(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/recuperarSenhaAdmin`, { email });

            if (data.status === 200) {
                notify.success("Enviamos um e-mail com as instruções para redefinir sua senha.");
                setEmail('');
                handleClose();
            } else {
                notify.error("E-mail não encontrado.");
            }
        } catch (error) {
            notify.error(getErrorMessage(error, "Não foi possível enviar o e-mail de recuperação."));
        } finally {
            setLoading(false);
        }
    }

    return (
        <FormDialog
            open={props.modalRecuperarSenha}
            onClose={handleClose}
            onSubmit={handleChangePassword}
            title="Recuperar senha"
            description="Informe o e-mail cadastrado. Enviaremos um link para você criar uma nova senha."
            submitLabel="Enviar link"
            loading={loading}
            maxWidth="xs"
        >
            <TextField
                autoFocus
                required
                label="E-mail"
                placeholder="nome@contblack.com.br"
                type="email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="small"
                autoComplete="off"
            />
        </FormDialog>
    );
}
